/* eslint-disable no-extra-boolean-cast */
import React, { useState } from 'react'
import { Dropdown, Form } from 'react-bootstrap'
import { Controller } from 'react-hook-form'

const DropDownControl = ({ label, options, error, control, name, showLabel = true }) => {
    return (
        <>
            {showLabel ? <Form.Label className="lcontrol">{label}</Form.Label> : ''}
            <Controller
                control={control && control}
                name={name}
                render={({ field: { value, onChange } }) => (
                    <Dropdown
                        onSelect={(e) => {
                            onChange(e)
                        }}>
                        <Dropdown.Toggle variant="success" id="dropdown-basic" className="icontrol">
                            {!!value ? value : label}
                        </Dropdown.Toggle>

                        <Dropdown.Menu> 
                            {options?.map((option, index) => {
                                return (
                                    <Dropdown.Item
                                        key={`option_${index}`}
                                        eventKey={option}
                                        value={option}>
                                        {option}
                                    </Dropdown.Item>
                                )
                            })}
                        </Dropdown.Menu>
                        {error && (
                            <span className="error-message" style={{ color: 'red' }}>
                                {error}
                            </span>
                        )}
                    </Dropdown>
                )}
            />
        </>
    )
}

export default DropDownControl
